module.exports = __webpack_public_path__ + "img/workflowSettings_03.18d467b7.png";